{
  "production": false,
  "SentryDSN": "https://ad24f2fb428d442f9a99fb99ec5b35ec@o60635.ingest.sentry.io/5584113",
  "webApiUrl": "http://localhost:55254",
  "clientId": "TigerEyeAngular",
  "webUrl": "http://localhost:4200",
  "envName": "dev",
  "pusher": {
    "key": "614742e4d74b257573b7"
  },
  "growlTimeout": 3000,
  "gaTracking": true,
  "gaTrackingCode": "UA-112879726-1",
  "cosmeticURLDefault": "https://tigereyedev.tigerrisk.com",
  "pusherChannelPrefix": "Dev",
  "pollingInterval": 30000,
  "skipAPIVersioning": false,
  "Okta_CLIENT_ID": "0oaplu8xhNjLNV1WM4x6",
  "Okta_ISSUER": "https://tigereyelogin.tigerrisk.com/oauth2/default",
  "Okta_LOGIN_REDIRECT_URI": "http://localhost:4200/callback",
  "Okta_LOGOUT_REDIRECT_URI": "https://tigerrisk.okta.com/login/signout?fromURI=http://localhost:4200/login",
  "Okta_TigerRiskIDP": "0oakmekhl1Xi9lhhW4x6",
  "Okta_TigerRiskSwitchIDP": "0oapk0qdrFBL2Lc3y4x6"
}
